'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _has = require('lodash/has');var _has2 = _interopRequireDefault(_has);

var _CellPhotoBlock = require('../../components/OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);


var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _constants = require('../../constants');

var _ProjectCell = require('./ProjectCell.scss');var styles = _interopRequireWildcard(_ProjectCell);
var _images_placeholder = require('../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Styles
// Helpers
var ProjectCell = function ProjectCell(props) {var
  isMobile = props.isMobile,price = props.price,exactPrice = props.exactPrice,translate = props.translate,locale = props.locale;
  var isDefaultLanguage = locale === _constants.language.default;
  var priceLocalizationKey = isMobile || !isDefaultLanguage ? 'from' : 'startingFrom';
  var separator = isMobile ? ' ' : ' - ';
  var nis = String.fromCharCode(8362);
  var ltrSymbol = String.fromCharCode(8206);

  var renderImages = function renderImages() {
    var images = (props.images || []).map(function (item) {
      if ((0, _has2.default)(item, 'thumbnail')) {
        return item;
      }
      return { thumbnail: item };
    });
    var formattedPrice = exactPrice ? '' +
    ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
    translate(priceLocalizationKey) + separator + nis + (0, _beautifyNumber2.default)(price);

    return (
      _react2.default.createElement(_CellPhotoBlock2.default, {
        className: 'largePhoto',
        price: formattedPrice,
        photo: props.image,
        images: images,
        isRtl: props.isRtl,
        isFavorite: props.isFavorite,
        toggleFavorite: props.toggleFavorite,
        withoutCurrency: true,
        withoutPagination: true }));


  };

  return (
    _react2.default.createElement('div', { className: styles.projectCell, onMouseEnter: props.onHover, onClick: props.openDetails },
      _react2.default.createElement('div', { className: styles.imageSection },
        renderImages()),

      _react2.default.createElement('div', { className: styles.descriptionSection },
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.propertyType }, props.translate('header', 'projects')),
          _react2.default.createElement('div', { className: styles.projectInfo },
            _react2.default.createElement('div', null,
              _react2.default.createElement('div', { className: styles.name }, props.name),
              _react2.default.createElement('div', null, props.address.street_name, '\xA0', props.address.house_number, ','),
              _react2.default.createElement('div', null, props.address.city_name)),

            _react2.default.createElement('div', { className: styles.logoProjectWrapper },
              _react2.default.createElement('img', { alt: '', src: props.logo })))),



        _react2.default.createElement('div', { className: styles.status },
          _react2.default.createElement('div', null,
            _react2.default.createElement('b', null, props.translate('status'), ':\xA0'),
            props.status),

          props.note))));




};

ProjectCell.propTypes = {
  images: _propTypes2.default.array,
  image: _propTypes2.default.string,
  price: _propTypes2.default.number,
  exactPrice: _propTypes2.default.number,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  logo: _propTypes2.default.string,
  name: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  address: _propTypes2.default.object,
  status: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  onHover: _propTypes2.default.func,
  openDetails: _propTypes2.default.func,
  location: _propTypes2.default.string,
  isFavorite: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  note: _propTypes2.default.node };exports.default =


ProjectCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCell/ProjectCell.js
// module id = 1225
// module chunks = 0